/**
 * Internal Task Registry — auto-assembled from carrier task definition files.
 * Parallel to taskRegistry but for internal (staff-only) tasks.
 */

import type { InternalTaskName } from './constants';
import type { InternalTaskConfig } from './types';
import { allBranchInternalTaskDefinitions } from '../carriers/branch/internal-tasks';

export const internalTaskRegistry = Object.fromEntries(
  allBranchInternalTaskDefinitions.map((def) => [def.taskName, def.config])
) as Record<InternalTaskName, InternalTaskConfig>;
